import { Injectable } from '@angular/core';

const MP4_FORMAT = 'mp4';
const YOUTUBE_FORMAT = 'video';
const TEXT_FORMAT = 'text';

@Injectable({
  providedIn: 'root',
})
export class VideoUtilitiesService {
  original!: string;
  previusIsText!: boolean;

  constructor() {}

  getVideosFromText(text: string): any[] {
    let arrayText: {}[] = [];
    const originalText = text.split('\n');
    originalText.forEach((element: any) => {
      const isVideoYoutube = this.isVideoYoutube(element);
      const isVideoMp4 = this.isVideoMp4(element);
      if (isVideoYoutube || isVideoMp4) {
        const data = {
          text: element.substring(2, element.length - 2),
          type: isVideoYoutube ? YOUTUBE_FORMAT : MP4_FORMAT,
        };
        this.previusIsText = false;
        arrayText.push(data);
      } else {
        this.setTextElement(element, arrayText);
      }
    });
    return arrayText;
  }

  private isVideoYoutube(element: string): boolean {
    const regexYoutube = /{{([^}]*)}}/i;
    return element.search(regexYoutube) !== -1;
  }
  private isVideoMp4(element: string): boolean {
    const regexMp4 = /!{([^}]*)}!/i;
    return element.search(regexMp4) !== -1;
  }

  private setTextElement(element: any, arrayText: any): void {
    if (arrayText.length > 0 && this.previusIsText) {
      arrayText[arrayText.length - 1].text = `${
        arrayText[arrayText.length - 1].text
      }\n${element}`;
    } else {
      this.previusIsText = true;
      const data = {
        text: element,
        type: TEXT_FORMAT,
      };
      arrayText.push(data);
    }
  }
  // spot all videos
  stopVideos(): void {
    if (document.querySelectorAll('iframe') !== null) {
      const elements = document.querySelectorAll('iframe');
      elements.forEach((element: any) => {
        const youtubeCommand = JSON.stringify({
          event: 'command',
          func: 'pauseVideo',
        });
        element.contentWindow.postMessage(youtubeCommand, '*');
      });
    }
    if (document.querySelectorAll(YOUTUBE_FORMAT) !== null) {
      const elements = document.querySelectorAll(YOUTUBE_FORMAT);
      elements.forEach((element: any) => {
        element.pause();
      });
    }
  }
}
